import { OrderStateStatus } from '../constants';
import { OrderHistoryItem, OrderLine } from '../models';

export abstract class OrderActionsVisibility {
  public abstract order: OrderHistoryItem;
  public abstract isGetInvoiceFeatureEnabled: boolean;

  public get isOrderReturnableByDays() {
    return this.order.orderLines
      .every((orderLine: OrderLine) => orderLine.allowedTransitions.requestReturn);
  }

  public get isAllowedCancelOrder(): boolean {
    const allowedStatuses = [OrderStateStatus.PLACED, OrderStateStatus.PAID];

    return this.order.orderLines.some((orderLine: OrderLine) =>
      allowedStatuses.includes(orderLine.status.value));
  }

  public get isAllowedReturnOrder(): boolean {
    return this.order.orderLines.every((orderLine: OrderLine) =>
        orderLine.status.value === OrderStateStatus.SHIPPED && !orderLine.referenceLine);
  }

  public get isAllowedCancelReturningOrder(): boolean {
    return this.order.orderLines.every((orderLine: OrderLine) =>
        orderLine.status.value === OrderStateStatus.RETURN_REQUESTED);
  }

  public get isAllowedDownloadInvoicesDocs(): boolean {
    return this.isGetInvoiceFeatureEnabled && this.order.orderLines.some((orderLine: OrderLine) => {
      return [
        OrderStateStatus.SHIPPED,
        OrderStateStatus.RETURN_DECLINED,
        OrderStateStatus.RETURN_REQUESTED,
        OrderStateStatus.RETURN_ACCEPTED,
      ].includes(orderLine.status.value);
    });
  }

  public get isInvoiceDocumentsAttached(): boolean {
    return this.order.orderLines.some((orderLine: OrderLine) =>
      Object.values(orderLine.documents).some(documents => documents.length));
  }

  public get shouldShowContextualMenu(): boolean {
    return (
      this.isAllowedCancelOrder ||
      this.isAllowedReturnOrder ||
      this.isAllowedCancelReturningOrder
    );
  }
}
